import { render } from "./Debtor_Statement.vue?vue&type=template&id=f387a8de&scoped=true"
import script from "./Debtor_Statement.vue?vue&type=script&lang=js"
export * from "./Debtor_Statement.vue?vue&type=script&lang=js"

import "./Debtor_Statement.vue?vue&type=style&index=0&id=f387a8de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f387a8de"]])

export default __exports__